export default "__VITE_ASSET__DMg_J01R__"